import injector from 'vue-inject'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    createDraftState: { type: injector.get('apiStateType').idle },
    deleteDraftState: { type: injector.get('apiStateType').idle },
    getCurrentDraftState: { type: injector.get('apiStateType').idle },
    updateCurrentDraftState: { type: injector.get('apiStateType').idle },
    menuDraftList: [],
    currentDraft: null,
    modificationCount: 0,
    currentElementPath: []
  },
  getters: {
  },
  mutations,
  actions
}
